import React, { useState } from "react";
import {
  FaEnvelopeOpenText,
  FaPhoneVolume,
  FaLinkedinIn,
  FaYoutube,
  FaStar,
  FaGoogle,
  FaWhatsapp,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Logo from "../images/logo/ezcarrentals-Newlogo.png";

import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../lib/firebase";
import { Alert, AlertTitle, Snackbar } from "@mui/material";

const GOOGLE_RATING = 4.9;
const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/search/?api=1&query=EZ+Car+Rentals+33B+Clifford+Street+Huntingdale";

function Footer() {
  const emailAddress = "info@ezcarrentals.com.au";
  const phoneNumber = "0400 920 512";
  const firestore = db;

  const [email, setEmail] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const handleSubmit = async () => {
    if (!email) {
      setAlertMessage("Please enter an email address.");
      setAlertSeverity("error");
      setAlertOpen(true);
      return;
    }

    try {
      await addDoc(collection(firestore, "subscriptions"), {
        email: email,
        timestamp: Timestamp.now(),
      });
      setAlertMessage("Subscription successful!");
      setAlertSeverity("success");
      setAlertOpen(true);
      setEmail("");
    } catch (error) {
      console.error("Error subscribing:", error);
      setAlertMessage("Subscription failed. Please try again.");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };

  return (
    <>
      <footer className='footer'>
        <div className='container'>
          <div className='footer-content'>
            <ul className='footer-content__1'>
              <li>
                <div className='navbar__img'>
                  <Link to='/' onClick={() => window.scrollTo(0, 0)}>
                    <img
                      src={Logo}
                      alt='EZ Car Rentals Logo'
                      style={{
                        width: "200px",
                        height: "auto",
                        display: "block",
                        margin: "0 auto",
                      }}
                    />
                  </Link>
                </div>
              </li>
              <li>Your friendly, local car hire in Melbourne!</li>
              <li>
                <a href={`tel:${phoneNumber}`}>
                  <FaPhoneVolume />
                  &nbsp;{phoneNumber}
                </a>
              </li>
              <li>
                <a href={`mailto:${emailAddress}`}>
                  <FaEnvelopeOpenText /> &nbsp;
                  {emailAddress}
                </a>
              </li>
              <li>
                <a
                  className='footer-google-rating'
                  href={GOOGLE_REVIEWS_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label={`Google rating ${GOOGLE_RATING} out of 5`}
                >
                  <FaGoogle className='footer-google-rating__icon' aria-hidden='true' />
                  <span className='footer-google-rating__label'>Google</span>
                  <span className='footer-google-rating__stars' aria-hidden='true'>
                    {[1, 2, 3, 4, 5].map((star) => (
                      <FaStar key={star} />
                    ))}
                  </span>
                  <strong className='footer-google-rating__value'>{GOOGLE_RATING}</strong>
                  <span className='footer-google-rating__out'>/ 5</span>
                </a>
              </li>
              <li>
                <div className='footer-social'>
                  <a
                    href='https://www.instagram.com/ezcarrentals_aus/'
                    className='socialContainer containerOne'
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label='Follow EZ Car Rentals on Instagram'
                  >
                    <svg
                      className='socialSvg instagramSvg'
                      viewBox='0 0 16 16'
                      aria-hidden='true'
                    >
                      <path d='M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z' />
                    </svg>
                  </a>
                  <a
                    href='https://www.facebook.com/EZCarRentalsMelbourne'
                    className='socialContainer containerFacebook'
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label='Follow EZ Car Rentals on Facebook'
                  >
                    <svg
                      className='socialSvg facebookSvg'
                      viewBox='0 0 16 16'
                      aria-hidden='true'
                    >
                      <path
                        fillRule='evenodd'
                        d='M9.628 1.99H7.247c-2.377 0-4.33 1.953-4.33 4.33v2.38H1.99v2.971h1.927v6.393h3.064V9.682h2.038l.284-2.971H6.92V5.572c0-1.128.106-1.751 1.738-1.751H9.63V1.99z'
                      />
                    </svg>
                  </a>
                  <a
                    href='https://www.linkedin.com/company/ezcarrentals/'
                    className='socialContainer containerThree'
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label='Follow EZ Car Rentals on LinkedIn'
                  >
                    <FaLinkedinIn className='socialSvg' aria-hidden='true' />
                  </a>
                  <a
                    href='https://wa.me/61400920512'
                    className='socialContainer containerFour'
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label='Chat with EZ Car Rentals on WhatsApp'
                  >
                    <FaWhatsapp className='socialSvg' aria-hidden='true' />
                  </a>
                  <a
                    href='https://www.youtube.com/@EZCarRentals'
                    className='socialContainer containerYouTube'
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label='Subscribe to EZ Car Rentals on YouTube'
                  >
                    <FaYoutube className='socialSvg' aria-hidden='true' />
                  </a>
                </div>
              </li>
            </ul>
            <ul className='footer-content__2'>
              <li>Working Hours</li>
              <li>
                We work only on appointment basis. But we can be reached out
              </li>
              <li>Mon - Fri: 8:00AM - 8:00PM</li>
              <li>Sat: 8:00AM - 8:00PM</li>
              <li>Sun: 8:00AM - 8:00PM</li>
              <li>
                <Link to='/privacy-policy'>Privacy Policy</Link>
              </li>
            </ul>
            <ul className='footer-content__2'>
              <li>Subscription</li>
              <li>
                <p>
                  Subscribe your Email address for the latest news & updates.
                </p>
              </li>
              <li>
                <label htmlFor='footer-email' className='visually-hidden'>
                  Email address for newsletter
                </label>
                <input
                  type='email'
                  placeholder='Enter Email Address'
                  id='footer-email'
                  name='email'
                  value={email}
                  autoComplete='email'
                  onChange={(e) => setEmail(e.target.value)}
                />
              </li>
              <li>
                <button className='submit-email' onClick={handleSubmit}>
                  Submit
                </button>
              </li>
            </ul>

            <Snackbar
              open={alertOpen}
              autoHideDuration={6000}
              onClose={() => setAlertOpen(false)}
            >
              <Alert
                onClose={() => setAlertOpen(false)}
                severity={alertSeverity}
              >
                <AlertTitle>
                  {alertSeverity.charAt(0).toUpperCase() +
                    alertSeverity.slice(1)}
                </AlertTitle>
                {alertMessage}
              </Alert>
            </Snackbar>
          </div>
        </div>
      </footer>
      <div className='footer-bottom'>
        Designed and Developed by{" "}
        <a href='https://praveenpremasinghe-me.netlify.app/'> Zero I N D E X </a>{" "}
        &copy; 2025 All Rights Reserved
      </div>
    </>
  );
}

export default Footer;
